import { render, staticRenderFns } from "./works-article.vue?vue&type=template&id=511291cc&"
import script from "./works-article.vue?vue&type=script&lang=js&"
export * from "./works-article.vue?vue&type=script&lang=js&"
import style0 from "./works-article.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports